import { render, staticRenderFns } from "./DashGraph.vue?vue&type=template&id=bb8c772e&scoped=true"
import script from "./DashGraph.vue?vue&type=script&lang=js"
export * from "./DashGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8c772e",
  null
  
)

export default component.exports